import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../utils/axiosSetup.js';


const ViewClient = ({clientId}) => {
    const [clientData, setClientData] = useState(null);
    const [channels, setChannel] = useState([]);
   
    const fetchClient = async (clientId) => {      
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/clients/${clientId}`)
            .then(response => {
                setClientData(response.data.data);     
            })
            .catch(error => {
                console.log(error);
                setClientData([]); 
            });
    }

    const fetchChannels = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/channels`)
            .then(response => {
                setChannel(response.data.data);
            })
            .catch(error => {
                console.error('Error fetching channels', error);
                setChannel([]);
            });
    };

    useEffect(() => {
        if (clientId) {
            fetchClient(clientId);
        }
        fetchChannels();
    },[clientId]);

    if (!clientId || !clientData) {
        return null;
    }

    return (
        <div id={`view_client_${clientId}`} className="modal custom-modal fade" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">View Client - {clientData.name}</h5>                        
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Channel</label>
                                        <select className="form-control" value={clientData.channel_id || ""} disabled>
                                            <option value="">Select channel</option>
                                            {channels.map(channel => (
                                                <option key={channel.id} value={channel.id}>{channel.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                {/* <div className="col-sm-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Name</label>
                                        <input className="form-control" type="text" value={clientData.name} />
                                    </div>
                                </div> */}
                                <div className="col-sm-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Description</label>
                                        <textarea className="form-control" value={clientData.description || ""} rows={3} disabled />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewClient